// src/aws-exports.js
const awsConfig = {
  aws_project_region: process.env.REACT_APP_AWS_REGION,
  aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_AWS_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_APP_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_AWS_COGNITO_DOMAIN,
    scope: process.env.REACT_APP_AWS_COGNITO_SCOPE,
    redirectSignIn: process.env.REACT_APP_AWS_COGNITO_REDIRECT_SIGN_IN,
    redirectSignOut: process.env.REACT_APP_AWS_COGNITO_REDIRECT_SIGN_OUT,
    responseType: process.env.REACT_APP_RESPONSE_TYPE // or "token"
  }
};

export default awsConfig;
